import { Node, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

type ParagraphPictureListProps = {
  children: React.ReactNode;
};

const isNodeAllowed = (type) =>
  ["Text", "Image", "ParagraphItem"].includes(type);

const StyledDiv = withViewportStyle("div")`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${rem(24)};
  ${(props) =>
    props.$viewport.mobile`
      grid-template-columns: auto;
    `}    
`;

export default function ParagraphPictureList(props: ParagraphPictureListProps) {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <StyledDiv ref={connect} data-testid="paragraph-picture-list" {...props}>
      {props.children}
    </StyledDiv>
  );
}

ParagraphPictureList.craft = {
  custom: {
    displayName: "Paragraph & Picture List",
  },
  rules: {
    canMoveIn: (nodes: Node[]) => {
      const nodeTypes = nodes?.map((node) => node?.type);
      return nodeTypes.length > 0 && nodeTypes.every(isNodeAllowed);
    },
  },
};
